<template>
  <div>
    <CRow>
      <CCol
        v-for="item in data"
        :key="item.topic"
        col="12"
        :sm="6"
        :lg="item.cols"
      >
        <CWidgetProgress :footer="item.lastMonth | decimalFormat | lastMonth">
          <div class="card-header-actions">
            <i :class="item.icon"></i>
          </div>
          <div class="h3 m-0 text-info">
            <b>{{ item.current | decimalFormat }}</b>
          </div>
          <div class="h5 m-0">{{ item.topic }}</div>
        </CWidgetProgress>
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: 'WidgetStatistic',
  props: {
    data: Array
  },
  filters: {
    lastMonth(amount) {
      return amount ? `เดือนก่อน ( ${amount} )` : '\u00A0'
    }
  }
}
</script>
